import { useDispatch } from "react-redux";
import { EligibilityGrid } from "./EligibilityGrid";
import { useEffect } from "react";
import { setPageTitle } from "../../store/slices/pageTitleSlice";

export const Eligibility = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle('Eligible Patients | Spire360'));
  }, []);

  return (
    <>
      <EligibilityGrid breadcrumbs={true}/>
    </>
  );
};
